export const STAFF = [
  {
    num: "01",
    name: "Michael Lewis",
    role: "President of Sports Operations",
    image: "/staff/michael-lewis.png",
    college: "University of Nevada, Las Vegas",
    hometown: "South San Francisco, CA",
    bio: "A 40+ year veteran of the sports industry. A three-sport collegiate and professional athlete, veteran sports broadcaster for the WNBA Sacramento Monarchs, and a coach with over 600 wins and numerous awards. Brings unmatched knowledge of the professional sports arena and sports management. Also serves as Project General Manager, Executive Director of Sports Events, and Southwest Division Director.",
  },
  {
    num: "02",
    name: "Justin Allen",
    role: "Vice President & CFO — National Division",
    image: "/staff/justin-allen.png",
    college: "Cheyney University",
    hometown: "Baltimore, MD",
    bio: "A powerful presence among the top entrepreneurs in the Washington DC metropolitan area for over a decade. Known for excellence in developing and growing businesses across the community alongside a successful security business. Holds a Bachelor of Business Administration from Cheyney University with numerous awards and licenses.",
  },
  {
    num: "03",
    name: "Wayne Wooten",
    role: "Director of International & Regional Scouting — National Division",
    image: "/staff/wayne-wooten.png",
    hometown: "Raleigh, NC",
    bio: "One of the sports industry's most accomplished basketball professionals. His career spans international FIBA, the NBA G League, and NCAA — bringing deep expertise in coaching, player development, and scouting across both US and international markets.",
  },
  {
    num: "04",
    name: "Javan Smith",
    role: "Director of Operations — International Division (Pacific Rim)",
    image: "/staff/javan-smith.png",
    college: "Palm Beach State College",
    hometown: "Palm Beach, FL",
    bio: "A former college and overseas basketball star with strong international management expertise in team ownership. Operates a 3x3 tournament basketball platform and brings sharp sports-management expertise to every play AfroAm makes.",
  },
  {
    num: "05",
    name: "Musa Shabazz",
    role: "Player Development / Assistant — International Division (Senegal)",
    image: "/staff/musa-shabazz.png",
    bio: "A former college and overseas athlete with deep on-court experience. Known for developing and recruiting collegiate and professional talent — sharpening the next generation, one rep at a time.",
  },
  {
    num: "06",
    name: "ZaRaya Porter",
    role: "College Intern Recruitment Director — Southwest Division",
    image: "/staff/zaraya-porter.png",
    college: "Prairie View A&M University",
    hometown: "Fairfield, CA",
    bio: "Leads year-round recruitment of college undergraduates into AfroAm internship opportunities across operations, marketing, scouting, media, and community programs. Champions the next generation of front-office talent — opening doors on campuses nationwide.",
  },
  {
    num: "07",
    name: "Raven Hudson",
    role: "Regional Director — Houston Region",
    image: "/staff/raven-hudson.jpg",
    college: "Sam Houston State University",
    hometown: "Houston, Texas",
    bio: "Leads the Houston region — overseeing athlete relocation and housing across Metro Houston, driving sports projects, marketing, and promotions for AfroAm. Ensures every athlete who arrives in the Southwest has a soft landing and a clear path forward.",
  },
  {
    num: "08",
    name: "Shardee Noel",
    role: "Legal Counsel Executive / CFO — Southwest Division",
    image: "/staff/sherrelle-noel.jpg",
    college: "Stephen F. Austin State University",
    hometown: "Houston, Texas",
    bio: "Leads the review and development of legal documents and compliance for AfroAm, and manages the financials for the Southwest Division. Brings sharp legal rigor and disciplined financial stewardship to every move the division makes.",
  },
  {
    num: "09",
    name: "Gianna Trotter",
    role: "National Events Director",
    image: "/staff/gianna-trotter.png",
    college: "Texas Southern University",
    hometown: "Fond du Lac, Wisconsin",
    bio: "Orchestrates AfroAm's national event slate — showcases, tournaments, community activations, and league-wide programming. Brings sharp operational focus and a deep production playbook to every event the organization stages.",
  },
];
